import coursesImg1 from './assets/images/courses old military.webp';
import coursesImg2 from './assets/images/courses first aid.webp';
import coursesImg3 from './assets/images/courses fire safety.webp';
import coursesImg4 from './assets/images/courses personal safety.webp';
import { IProgramCost } from './enteties/IProgramCost';
import clientCourseimg1 from './assets/images/clientsCourse1.webp';
import clientCourseimg2 from './assets/images/clientsCourse2.webp';
import clientCourseimg3 from './assets/images/clientsCourse3.webp';
import clientCourseimg4 from './assets/images/clientsCourse4.webp';
import clientCourseimg5 from './assets/images/clientsCourse5.webp';
import clientCourseimg6 from './assets/images/pistol.webp';
import clientCourseimg8 from './assets/images/rf15.png';
import clientCourseimg7 from './assets/images/clientsCourse7.webp';
import ClientsBenefitsIcon1 from './assets/icons/ClientsBenefitsIcon1';
import ClientsBenefitsIcon2 from './assets/icons/ClientsBenefitsIcon2';
import ClientsBenefitsIcon3 from './assets/icons/ClientsBenefitsIcon3';
import ClientsBenefitsIcon4 from './assets/icons/ClientsBenefitsIcon4';
import ClientsBenefitsIcon5 from './assets/icons/ClientsBenefitsIcon5';
import ClientsBenefitsIcon6 from './assets/icons/ClientsBenefitsIcon6';
import ClientsBenefitsIcon7 from './assets/icons/ClientsBenefitsIcon7';
import img1 from './assets/images/locationsFireZone.webp';
import img2 from './assets/images/locationTir.webp';
import img3 from './assets/images/locationGym.webp';
import img4 from './assets/images/locationConference.webp';
import img5 from './assets/images/locationsSmall.webp';
import { translations } from './i18n/translations';

import certificatesDataCourse1Img from './assets/images/courseCertificat1.webp';
import certificatesDataCourse2Img from './assets/images/courseCertificat2.webp';
import certificatesDataCourse3Img from './assets/images/courseCertificat3.webp';
import certificatesDataCourse4Img from './assets/images/courseCertificat4.webp';
import getTranslationByLangOrUk from './utils/getTranslationByLangOrUk';

export const mainPageCoursesData: (lang: string) => {img: string, title: string, path: string, description: string}[] = (lang) => [
  {
    img: coursesImg1,
    title: translations[lang].courses_1_title,
    description: translations[lang].courses_1_description,
    path: '/courses/basic-course-in-handling-weapons',
  },
  {
    img: coursesImg2,
    title: translations[lang].courses_2_title,
    description: translations[lang].courses_2_description,
    path: '/courses/basic-course-emergency-aid',
  },
  {
    img: coursesImg3,
    title: translations[lang].courses_3_title,
    description: translations[lang].courses_3_description,
    path: '/courses/basic-fire-safety-course',
  },
  {
    img: coursesImg4,
    title: translations[lang].courses_4_title,
    description: translations[lang].courses_4_description,
    path: '/courses/basic-personal-safety-course',
  },
];

export const coursesData: (lang: string) => {img: string, title: string, path: string, description: string, settings?: {imageSize: 'cover' | 'contain'}}[] = (lang) => [
  {
    img: coursesImg1,
    title: translations[lang].courses_1_title,
    description: translations[lang].courses_1_description,
    path: '/courses/basic-course-in-handling-weapons',
  },
  {
    img: clientCourseimg6,
    title: getTranslationByLangOrUk(lang, 'courses_6_title'),
    description: getTranslationByLangOrUk(lang, 'courses_6_description'),
    path: '/courses/pistol-course',
  },
  {
    img: clientCourseimg8,
    title: getTranslationByLangOrUk(lang, 'courses_8_title'),
    description: getTranslationByLangOrUk(lang, 'courses_8_description'),
    path: '/courses/rf15-course',
    settings: {
      imageSize: 'contain',
    },
  },
  {
    img: clientCourseimg5,
    title: getTranslationByLangOrUk(lang, 'courses_5_title'),
    description: getTranslationByLangOrUk(lang, 'courses_5_description'),
    path: '/courses/ak-47-course',
  },
  {
    img: coursesImg2,
    title: translations[lang].courses_2_title,
    description: translations[lang].courses_2_description,
    path: '/courses/basic-course-emergency-aid',
  },
  {
    img: coursesImg3,
    title: translations[lang].courses_3_title,
    description: translations[lang].courses_3_description,
    path: '/courses/basic-fire-safety-course',
  },
  {
    img: coursesImg4,

    title: translations[lang].courses_4_title,
    description: translations[lang].courses_4_description,
    path: '/courses/basic-personal-safety-course',
  },
  {
    img: clientCourseimg7,

    title: translations[lang].course_march_title,
    description: translations[lang].course_march_description,
    path: '/courses/march-course',
  },
];

export const navigationData: (lang: string) => {path: string, name: string}[] = (lang) => [
  {
    name: getTranslationByLangOrUk(lang, 'navigation_1'),
    path: '/courses',
  },
  {
    name: getTranslationByLangOrUk(lang, 'navigation_2'),
    path: '/shooting-gallery',
  },
  {
    name: translations[lang].corporate_clients,
    path: '/clients',
  },
  {
    name: getTranslationByLangOrUk(lang, 'navigation_3'),
    path: '/gift-certificates',
  },
  // {
  //   name: translations[lang].announces,
  //   path: '/announces',
  // },
  // {
  //   name: translations[lang].blog,
  //   path: '/blog',
  // },
  {
    name: translations[lang].rent,
    path: '/rent',
  },
  {
    name: translations[lang].contacts,
    path: '/contacts',
  },
  {
    name: translations[lang].about_us,
    path: '/about-us',
  },
];

export const mainPageLocationImages: (lang: string) => {title: string, image: string}[] = (lang) => [
  {
    image: img1,
    title: translations[lang].locations_fire_zone,
  },
  {
    image: img2,
    title: translations[lang].locations_shooting_gallery,
  },
  {
    image: img3,
    title: translations[lang].locations_training_room,
  },
  {
    image: img4,
    title: translations[lang].locations_conference_hall,
  },
  {
    image: img5,
    title: translations[lang].locations_small_hall,
  },
];

export const weaponProgramData: (lang: string) => {title: string, subtitle?: string, listData: string[]}[] = (lang) => [
  {
    title: translations[lang].weapon_course_program_1_title,
    subtitle: translations[lang].weapon_course_program_1_subtitle,
    listData: [
      translations[lang].weapon_course_program_1_list_item_1,
      translations[lang].weapon_course_program_1_list_item_2,
      translations[lang].weapon_course_program_1_list_item_3,
      translations[lang].weapon_course_program_1_list_item_4,
      translations[lang].weapon_course_program_1_list_item_5,
      translations[lang].weapon_course_program_1_list_item_6,
    ],
  },
  {
    title: translations[lang].weapon_course_program_2_title,
    listData: [
      translations[lang].weapon_course_program_2_list_item_1,
      translations[lang].weapon_course_program_2_list_item_2,
      translations[lang].weapon_course_program_2_list_item_3,
      translations[lang].weapon_course_program_2_list_item_4,
      translations[lang].weapon_course_program_2_list_item_5,
      translations[lang].weapon_course_program_2_list_item_6,
    ],
  },
];

export const firstAidProgramData: (lang: string) => {title: string, subtitle?: string, listData: string[]}[] = (lang) => ([
  {
    title: translations[lang].course_first_aid_program_1_title,
    subtitle: translations[lang].course_first_aid_program_1_subtitle,
    listData: [
      translations[lang].course_first_aid_program_1_list_item_1,
      translations[lang].course_first_aid_program_1_list_item_2,
      translations[lang].course_first_aid_program_1_list_item_3,
      translations[lang].course_first_aid_program_1_list_item_4,
      translations[lang].course_first_aid_program_1_list_item_5,
      translations[lang].course_first_aid_program_1_list_item_6,
      translations[lang].course_first_aid_program_1_list_item_7,
      translations[lang].course_first_aid_program_1_list_item_8,
    ],
  },
  {
    title: translations[lang].course_first_aid_program_2_title,
    subtitle: translations[lang].course_first_aid_program_2_subtitle,
    listData: [
      translations[lang].course_first_aid_program_2_list_item_1,
      translations[lang].course_first_aid_program_2_list_item_2,
      translations[lang].course_first_aid_program_2_list_item_3,
      translations[lang].course_first_aid_program_2_list_item_4,
      translations[lang].course_first_aid_program_2_list_item_5,
    ],
  },
]);

export const personalSafetyProgramData: (lang: string) => {title: string, subtitle?: string, listData: string[]}[] = (lang) => [
  {
    title: translations[lang].courses_personal_safety_program_1_title,
    listData: [
      translations[lang].courses_personal_safety_program_1_list_item_1,
      translations[lang].courses_personal_safety_program_1_list_item_2,
      translations[lang].courses_personal_safety_program_1_list_item_3,
      translations[lang].courses_personal_safety_program_1_list_item_4,
      translations[lang].courses_personal_safety_program_1_list_item_5,
      translations[lang].courses_personal_safety_program_1_list_item_6,
    ],
  },
  {
    title: translations[lang].courses_personal_safety_program_2_title,
    listData: [
      translations[lang].courses_personal_safety_program_2_list_item_1,
      translations[lang].courses_personal_safety_program_2_list_item_2,
      translations[lang].courses_personal_safety_program_2_list_item_3,
      translations[lang].courses_personal_safety_program_2_list_item_4,
      translations[lang].courses_personal_safety_program_2_list_item_5,
    ],
  },
];

export const fireSafetyProgramData: (lang: string) => {title: string, subtitle?: string, listData: string[]}[] = (lang) => [
  {
    title: translations[lang].courses_fire_safety_program_1_title,
    subtitle: translations[lang].courses_fire_safety_program_1_subtitle,
    listData: [
      translations[lang].courses_fire_safety_program_1_list_item_1,
      translations[lang].courses_fire_safety_program_1_list_item_2,
      translations[lang].courses_fire_safety_program_1_list_item_3,
      translations[lang].courses_fire_safety_program_1_list_item_4,
      translations[lang].courses_fire_safety_program_1_list_item_5,
      translations[lang].courses_fire_safety_program_1_list_item_6,
    ],
  },
  {
    title: translations[lang].courses_fire_safety_program_2_title,
    subtitle: translations[lang].courses_fire_safety_program_2_subtitle,
    listData: [
      translations[lang].courses_fire_safety_program_2_list_item_1,
      translations[lang].courses_fire_safety_program_2_list_item_2,
      translations[lang].courses_fire_safety_program_2_list_item_3,
      translations[lang].courses_fire_safety_program_2_list_item_4,
    ],
  },
];

export const rentProgramData: (lang: string) => {title: string, subtitle?: string, listData: string[]}[] = (lang) => ([
  {
    title: translations[lang].rent_program_title,
    listData: [
      translations[lang].rent_program_list_item_1,
      translations[lang].rent_program_list_item_2,
      translations[lang].rent_program_list_item_3,
      translations[lang].rent_program_list_item_4,
      translations[lang].rent_program_list_item_5,
      translations[lang].rent_program_list_item_6,
      translations[lang].rent_program_list_item_7,
      translations[lang].rent_program_list_item_8,
    ],
  },
]);

export const weaponCourseData: (lang: string) => IProgramCost = (lang) => ({
  description: translations[lang].weapon_course_data_description,
  headListData: [
    translations[lang].weapon_course_data_head_list_1,
    translations[lang].weapon_course_data_head_list_2,
  ],
  courseOptions: [
    {
      title: translations[lang].weapon_course_data_options_1_title,
      price: '2500',
      listData: [
        translations[lang].weapon_course_data_options_1_list_1,
        translations[lang].weapon_course_data_options_1_list_2,
        translations[lang].weapon_course_data_options_1_list_3,
        translations[lang].weapon_course_data_options_1_list_4],
    },
    {
      title: translations[lang].weapon_course_data_options_2_title,
      price: '3600',
      listData: [
        translations[lang].weapon_course_data_options_2_list_1,
        translations[lang].weapon_course_data_options_2_list_2,
        translations[lang].weapon_course_data_options_2_list_3,
        translations[lang].weapon_course_data_options_2_list_4],
    },
  ],
});

export const firstAidCourseCostData: (lang: string) => IProgramCost = (lang) => ({
  description: translations[lang].course_first_aid_cost_data_description,
  headListData: [translations[lang].course_first_aid_cost_data_head_list_1],
  courseOptions: [
    {
      title: translations[lang].course_first_aid_cost_data_course_title,
      price: '900',
      listData: [
        translations[lang].course_first_aid_cost_data_course_list_data_1,
        translations[lang].course_first_aid_cost_data_course_list_data_2,
        translations[lang].course_first_aid_cost_data_course_list_data_3,
      ],
    },
  ],
});

export const personalSafetyCourseCostData: (lang: string) => IProgramCost = (lang) => ({
  description: translations[lang].course_personal_safety_cost_data_description,
  headListData: [translations[lang].course_personal_safety_cost_data_head_list_item_1, translations[lang].course_personal_safety_cost_data_head_list_item_2],
  courseOptions: [
    {
      title: translations[lang].course_personal_safety_cost_data_options_1_title,
      price: '1400',
      listData: [
        translations[lang].course_personal_safety_cost_data_options_1_list_item_1,
        translations[lang].course_personal_safety_cost_data_options_1_list_item_2,
        translations[lang].course_personal_safety_cost_data_options_1_list_item_3,
      ],
    },
  ],
});

export const fireSafetyCourseCostData: (lang: string) => IProgramCost = (lang) => ({
  description: translations[lang].courses_fire_safety_cost_data_description,
  headListData: [translations[lang].courses_fire_safety_cost_data_head_list_1],
  courseOptions: [
    {
      title: translations[lang].courses_fire_safety_cost_data_options_1_title,
      price: '1350',
      listData: [
        translations[lang].courses_fire_safety_cost_data_options_1_list_data_1,
        translations[lang].courses_fire_safety_cost_data_options_1_list_data_2,
        translations[lang].courses_fire_safety_cost_data_options_1_list_data_3,
      ],
    },
  ],
});

export const rentPricesData: (lang: string) => IProgramCost = (lang) => ({
  courseOptions: [
    {
      title: translations[lang].rent_prices_item_1_title,
      price: translations[lang].rent_prices_item_1_price,
      listData: [
        translations[lang].rent_prices_item_1_list_item_1,
        translations[lang].rent_prices_item_1_list_item_3,
      ],
    },
    {
      title: translations[lang].rent_prices_item_2_title,
      price: translations[lang].rent_prices_item_2_price,
      listData: [
        translations[lang].rent_prices_item_2_list_item_1,
        translations[lang].rent_prices_item_2_list_item_2,
      ],
    },
  ],
});

export const clientsWhoWeAreListData: (lang: string) => {number: string, caption: string, description: string}[] = (lang) => ([
  {
    number: '10+',
    caption: translations[lang].clients_who_we_are_list_data_1_caption,
    description: translations[lang].clients_who_we_are_list_data_1_description,
  },
  {
    number: '200+',
    caption: translations[lang].clients_who_we_are_list_data_2_caption,
    description: translations[lang].clients_who_we_are_list_data_2_description,
  },
  {
    number: '10 000+',
    caption: translations[lang].clients_who_we_are_list_data_3_caption,
    description: translations[lang].clients_who_we_are_list_data_3_description,
  },
]);

export const clientsCoursesListData: (lang: string) => {img: string, title: string, description: string, path: string}[] = (lang) => [
  {
    title: translations[lang].clients_who_we_are_courses_list_data_1_title,
    description: translations[lang].clients_who_we_are_courses_list_data_1_description,
    img: clientCourseimg1,
    path: '/courses/basic-course-in-handling-weapons',
  },
  {
    title: translations[lang].clients_who_we_are_courses_list_data_2_title,
    description: translations[lang].clients_who_we_are_courses_list_data_2_description,
    img: clientCourseimg2,
    path: '/courses/basic-course-emergency-aid',
  },
  {
    title: translations[lang].clients_who_we_are_courses_list_data_3_title,
    description: translations[lang].clients_who_we_are_courses_list_data_3_description,
    img: clientCourseimg3,
    path: '/courses/basic-fire-safety-course',
  },
  {
    title: translations[lang].clients_who_we_are_courses_list_data_4_title,
    description: translations[lang].clients_who_we_are_courses_list_data_4_description,
    img: clientCourseimg4,
    path: '/courses/basic-personal-safety-course',
  },
];

// export const weaponCourseData: IProgramCost = {
//   description: '',
//   headListData: [],
//   courseOptions: [
//     {
//       title: '',
//       price: '',
//       listData: [],
//     },
//   ],
// };

export const clientsBenefitsData: (lang: string) => {icon: any, title: string, description: string }[] = (lang) => ([
  {
    title: translations[lang].clients_benefits_data_item_1_title,
    description: translations[lang].clients_benefits_data_item_1_description,
    icon: ClientsBenefitsIcon1,
  },
  {
    title: translations[lang].clients_benefits_data_item_2_title,
    description: translations[lang].clients_benefits_data_item_2_description,
    icon: ClientsBenefitsIcon2,
  },
  {
    title: translations[lang].clients_benefits_data_item_3_title,
    description: translations[lang].clients_benefits_data_item_3_description,
    icon: ClientsBenefitsIcon3,
  },
  {
    title: translations[lang].clients_benefits_data_item_4_title,
    description: translations[lang].clients_benefits_data_item_4_description,
    icon: ClientsBenefitsIcon4,
  },
  {
    title: translations[lang].clients_benefits_data_item_5_title,
    description: translations[lang].clients_benefits_data_item_5_description,
    icon: ClientsBenefitsIcon5,
  },
  {
    title: translations[lang].clients_benefits_data_item_6_title,
    description: translations[lang].clients_benefits_data_item_6_description,
    icon: ClientsBenefitsIcon6,
  },
  {
    title: translations[lang].clients_benefits_data_item_7_title,
    description: translations[lang].clients_benefits_data_item_7_description,
    icon: ClientsBenefitsIcon7,
  },
]);

export const AboutWhyHereListData: (lang: string) => string[] = (lang) => [
  translations[lang].about_why_here_list_item_1,
  translations[lang].about_why_here_list_item_2,
  translations[lang].about_why_here_list_item_3,
  translations[lang].about_why_here_list_item_4,
  translations[lang].about_why_here_list_item_5,
  translations[lang].about_why_here_list_item_6,
];

export const aboutSafetyCourseListData: (lang: string) => string[] = (lang) => [
  translations[lang].about_safety_course_list_item_1,
  translations[lang].about_safety_course_list_item_2,
  translations[lang].about_safety_course_list_item_3,
  translations[lang].about_safety_course_list_item_4,
];

export const aboutMaterialBase1ListData: (lang: string) => string[] = (lang) => [
  translations[lang].about_material_base_list_data_1_item_1,
  translations[lang].about_material_base_list_data_1_item_2,
  translations[lang].about_material_base_list_data_1_item_3,
  translations[lang].about_material_base_list_data_1_item_4,
  translations[lang].about_material_base_list_data_1_item_5,
];

export const aboutMaterialBase2ListData: (lang: string) => string[] = (lang) => [
  translations[lang].about_material_base_list_data_2_item_1,
  translations[lang].about_material_base_list_data_2_item_2,
  translations[lang].about_material_base_list_data_2_item_3,
  translations[lang].about_material_base_list_data_2_item_4,
  translations[lang].about_material_base_list_data_2_item_5,
  translations[lang].about_material_base_list_data_2_item_6,
];

export const aboutForWhoListData: (lang: string) => string[] = (lang) => [
  translations[lang].about_who_for_list_item_1,
  translations[lang].about_who_for_list_item_2,
  translations[lang].about_who_for_list_item_3,
];

export const akCourseData = (lang: string) => ({
  subtitle: getTranslationByLangOrUk(lang, 'ak_course_5'),
  lists: [
    {
      title: getTranslationByLangOrUk(lang, 'ak_course_6'),
      program: [
        getTranslationByLangOrUk(lang, 'ak_course_7'),
        getTranslationByLangOrUk(lang, 'ak_course_8'),
        getTranslationByLangOrUk(lang, 'ak_course_9'),
        getTranslationByLangOrUk(lang, 'ak_course_10'),
        getTranslationByLangOrUk(lang, 'ak_course_11'),
        getTranslationByLangOrUk(lang, 'ak_course_12'),
        getTranslationByLangOrUk(lang, 'ak_course_13'),
      ],
      costList: [
        getTranslationByLangOrUk(lang, 'ak_course_14'),
        getTranslationByLangOrUk(lang, 'ak_course_15'),
        getTranslationByLangOrUk(lang, 'ak_course_16'),
      ],
      sublist: [
        getTranslationByLangOrUk(lang, 'ak_course_17'),
      ],
    },
    {
      title: getTranslationByLangOrUk(lang, 'ak_course_18'),
      program: [
        getTranslationByLangOrUk(lang, 'ak_course_19'),
        getTranslationByLangOrUk(lang, 'ak_course_20'),
        getTranslationByLangOrUk(lang, 'ak_course_21'),
        getTranslationByLangOrUk(lang, 'ak_course_22'),
        getTranslationByLangOrUk(lang, 'ak_course_23'),
        getTranslationByLangOrUk(lang, 'ak_course_24'),
        getTranslationByLangOrUk(lang, 'ak_course_25'),
      ],
      costList: [
        getTranslationByLangOrUk(lang, 'ak_course_26'),
        getTranslationByLangOrUk(lang, 'ak_course_27'),
        getTranslationByLangOrUk(lang, 'ak_course_28'),
      ],
    },
    {
      title: getTranslationByLangOrUk(lang, 'ak_course_29'),
      program: [
        getTranslationByLangOrUk(lang, 'ak_course_30'),
        getTranslationByLangOrUk(lang, 'ak_course_31'),
        getTranslationByLangOrUk(lang, 'ak_course_32'),
        getTranslationByLangOrUk(lang, 'ak_course_33'),
        getTranslationByLangOrUk(lang, 'ak_course_34'),
      ],
      costList: [
        getTranslationByLangOrUk(lang, 'ak_course_35'),
        getTranslationByLangOrUk(lang, 'ak_course_36'),
        getTranslationByLangOrUk(lang, 'ak_course_37'),
      ],
      sublist: [
        getTranslationByLangOrUk(lang, 'ak_course_38'),
        getTranslationByLangOrUk(lang, 'ak_course_39'),
      ],
      subtitle: getTranslationByLangOrUk(lang, 'ak_course_40'),
    },
  ],
});

export const rf15Course = (lang: string) => ({
  subtitle: getTranslationByLangOrUk(lang, 'rf_15_course_5'),
  lists: [
    {
      title: getTranslationByLangOrUk(lang, 'rf_15_course_6'),
      program: [
        getTranslationByLangOrUk(lang, 'rf_15_course_7'),
        getTranslationByLangOrUk(lang, 'rf_15_course_8'),
        getTranslationByLangOrUk(lang, 'rf_15_course_9'),
        getTranslationByLangOrUk(lang, 'rf_15_course_10'),
        getTranslationByLangOrUk(lang, 'rf_15_course_11'),
        getTranslationByLangOrUk(lang, 'rf_15_course_12'),
        getTranslationByLangOrUk(lang, 'rf_15_course_13'),
      ],
      costList: [
        getTranslationByLangOrUk(lang, 'rf_15_course_14'),
        getTranslationByLangOrUk(lang, 'rf_15_course_15'),
        getTranslationByLangOrUk(lang, 'rf_15_course_16'),
        getTranslationByLangOrUk(lang, 'rf_15_course_17'),
      ],
      sublist: [
        getTranslationByLangOrUk(lang, 'rf_15_course_18'),
      ],
    },
    {
      title: getTranslationByLangOrUk(lang, 'rf_15_course_19'),
      program: [
        getTranslationByLangOrUk(lang, 'rf_15_course_20'),
        getTranslationByLangOrUk(lang, 'rf_15_course_21'),
        getTranslationByLangOrUk(lang, 'rf_15_course_22'),
        getTranslationByLangOrUk(lang, 'rf_15_course_23'),
        getTranslationByLangOrUk(lang, 'rf_15_course_24'),
        getTranslationByLangOrUk(lang, 'rf_15_course_25'),
        getTranslationByLangOrUk(lang, 'rf_15_course_26'),
      ],
      costList: [
        getTranslationByLangOrUk(lang, 'rf_15_course_27'),
        getTranslationByLangOrUk(lang, 'rf_15_course_28'),
        getTranslationByLangOrUk(lang, 'rf_15_course_29'),
        getTranslationByLangOrUk(lang, 'rf_15_course_30'),
      ],
    },
    {
      title: getTranslationByLangOrUk(lang, 'rf_15_course_31'),
      program: [
        getTranslationByLangOrUk(lang, 'rf_15_course_32'),
        getTranslationByLangOrUk(lang, 'rf_15_course_33'),
        getTranslationByLangOrUk(lang, 'rf_15_course_34'),
        getTranslationByLangOrUk(lang, 'rf_15_course_35'),
        getTranslationByLangOrUk(lang, 'rf_15_course_36'),
      ],
      costList: [
        getTranslationByLangOrUk(lang, 'rf_15_course_37'),
        getTranslationByLangOrUk(lang, 'rf_15_course_38'),
        getTranslationByLangOrUk(lang, 'rf_15_course_39'),
        getTranslationByLangOrUk(lang, 'rf_15_course_40'),
      ],
      sublist: [
        getTranslationByLangOrUk(lang, 'rf_15_course_41'),
        getTranslationByLangOrUk(lang, 'rf_15_course_42'),
      ],
    },
  ],
});

export const pistolCourseData = (lang: string) => ({
  subtitle: getTranslationByLangOrUk(lang, 'pistol_course_5'),
  lists: [
    {
      title: getTranslationByLangOrUk(lang, 'pistol_course_6'),
      program: [
        getTranslationByLangOrUk(lang, 'pistol_course_7'),
        getTranslationByLangOrUk(lang, 'pistol_course_8'),
        getTranslationByLangOrUk(lang, 'pistol_course_9'),
        getTranslationByLangOrUk(lang, 'pistol_course_10'),
        getTranslationByLangOrUk(lang, 'pistol_course_11'),
        getTranslationByLangOrUk(lang, 'pistol_course_12'),
        getTranslationByLangOrUk(lang, 'pistol_course_13'),
      ],
      costList: [
        getTranslationByLangOrUk(lang, 'pistol_course_14'),
        getTranslationByLangOrUk(lang, 'pistol_course_15'),
        getTranslationByLangOrUk(lang, 'pistol_course_16'),
      ],
      sublist: [
        getTranslationByLangOrUk(lang, 'pistol_course_17'),
      ],
    },
    {
      title: getTranslationByLangOrUk(lang, 'pistol_course_18'),
      program: [
        getTranslationByLangOrUk(lang, 'pistol_course_19'),
        getTranslationByLangOrUk(lang, 'pistol_course_20'),
        getTranslationByLangOrUk(lang, 'pistol_course_21'),
        getTranslationByLangOrUk(lang, 'pistol_course_22'),
        getTranslationByLangOrUk(lang, 'pistol_course_23'),
        getTranslationByLangOrUk(lang, 'pistol_course_24'),
        getTranslationByLangOrUk(lang, 'pistol_course_25'),
      ],
      costList: [
        getTranslationByLangOrUk(lang, 'pistol_course_26'),
        getTranslationByLangOrUk(lang, 'pistol_course_27'),
        getTranslationByLangOrUk(lang, 'pistol_course_28'),
      ],
    },
    {
      title: getTranslationByLangOrUk(lang, 'pistol_course_29'),
      program: [
        getTranslationByLangOrUk(lang, 'pistol_course_30'),
        getTranslationByLangOrUk(lang, 'pistol_course_31'),
        getTranslationByLangOrUk(lang, 'pistol_course_32'),
        getTranslationByLangOrUk(lang, 'pistol_course_33'),
        getTranslationByLangOrUk(lang, 'pistol_course_34'),
        getTranslationByLangOrUk(lang, 'pistol_course_35'),
      ],
      costList: [
        getTranslationByLangOrUk(lang, 'pistol_course_36'),
        getTranslationByLangOrUk(lang, 'pistol_course_37'),
        getTranslationByLangOrUk(lang, 'pistol_course_38'),
      ],
      sublist: [
        getTranslationByLangOrUk(lang, 'pistol_course_39'),
        getTranslationByLangOrUk(lang, 'pistol_course_40'),
      ],
    },
  ],
});

export const ak47CourseData: (lang: string) => IProgramCost = (lang) => ({
  description: getTranslationByLangOrUk(lang, 'ak_course_41'),
  headListData: [
    getTranslationByLangOrUk(lang, 'ak_course_42'),
    getTranslationByLangOrUk(lang, 'ak_course_43'),
  ],
  subdescription: getTranslationByLangOrUk(lang, 'ak_course_44'),
  courseOptions: [
    {
      title: getTranslationByLangOrUk(lang, 'ak_course_45'),
      price: getTranslationByLangOrUk(lang, 'ak_course_46'),
      listData: [
        getTranslationByLangOrUk(lang, 'ak_course_47'),
        getTranslationByLangOrUk(lang, 'ak_course_48'),
        getTranslationByLangOrUk(lang, 'ak_course_49'),
        getTranslationByLangOrUk(lang, 'ak_course_50'),
        getTranslationByLangOrUk(lang, 'ak_course_51'),
      ],
    },
    {
      title: getTranslationByLangOrUk(lang, 'ak_course_52'),
      price: getTranslationByLangOrUk(lang, 'ak_course_53'),
      listData: [
        getTranslationByLangOrUk(lang, 'ak_course_54'),
        getTranslationByLangOrUk(lang, 'ak_course_55'),
        getTranslationByLangOrUk(lang, 'ak_course_56'),
        getTranslationByLangOrUk(lang, 'ak_course_57'),
      ],
    },
    {
      title: getTranslationByLangOrUk(lang, 'ak_course_58'),
      price: getTranslationByLangOrUk(lang, 'ak_course_59'),
      listData: [
        getTranslationByLangOrUk(lang, 'ak_course_60'),
        getTranslationByLangOrUk(lang, 'ak_course_61'),
        getTranslationByLangOrUk(lang, 'ak_course_62'),
        getTranslationByLangOrUk(lang, 'ak_course_63'),
      ],
    },
  ],
});

export const rf15CourseData: (lang: string) => IProgramCost = (lang) => ({
  description: getTranslationByLangOrUk(lang, 'rf_15_course_43'),
  headListData: [
    getTranslationByLangOrUk(lang, 'rf_15_course_44'),
    getTranslationByLangOrUk(lang, 'rf_15_course_45'),
  ],
  subdescription: getTranslationByLangOrUk(lang, 'rf_15_course_46'),
  courseOptions: [
    {
      title: getTranslationByLangOrUk(lang, 'rf_15_course_47'),
      price: getTranslationByLangOrUk(lang, 'rf_15_course_53'),
      listData: [
        getTranslationByLangOrUk(lang, 'rf_15_course_49'),
        getTranslationByLangOrUk(lang, 'rf_15_course_50'),
        getTranslationByLangOrUk(lang, 'rf_15_course_51'),
        getTranslationByLangOrUk(lang, 'rf_15_course_52'),
        getTranslationByLangOrUk(lang, 'rf_15_course_48'),
      ],
    },
    {
      title: getTranslationByLangOrUk(lang, 'rf_15_course_54'),
      price: getTranslationByLangOrUk(lang, 'rf_15_course_59'),
      listData: [
        getTranslationByLangOrUk(lang, 'rf_15_course_56'),
        getTranslationByLangOrUk(lang, 'rf_15_course_57'),
        getTranslationByLangOrUk(lang, 'rf_15_course_58'),
        getTranslationByLangOrUk(lang, 'rf_15_course_55'),
      ],
    },
    {
      title: getTranslationByLangOrUk(lang, 'rf_15_course_60'),
      price: getTranslationByLangOrUk(lang, 'rf_15_course_65'),
      listData: [
        getTranslationByLangOrUk(lang, 'rf_15_course_62'),
        getTranslationByLangOrUk(lang, 'rf_15_course_63'),
        getTranslationByLangOrUk(lang, 'rf_15_course_64'),
        getTranslationByLangOrUk(lang, 'rf_15_course_61'),
      ],
    },
  ],
});

export const pistolCourseProgramData = {
  subtitle: '(3 персональні методичні заняття)',
  lists: [
    {
      title: 'Перше заняття: ПІСТОЛЕТ. БАЗОВИЙ.',
      program: [
        'Заходи безпеки.',
        'Тактико-технічні характеристики зброї.',
        'Розбирання. Збирання. Чищення.',
        'Формування хвату.',
        'Базова стійка. Прицілювання.',
        'Здійснення пострілу. Зміна магазина.',
        'Домашнє завдання.',
      ],
      costList: [
        'Тривалість: 2 години',
        'Вартість: 4000 грн (до 2х осіб)',
        '30 пострілів',
      ],
      sublist: [
        'По закінченню заняття, (за умові успішного складання заліку), видається Довідка про проходження курсу вивчення матеріальної частини зброї, правил поводження з нею та застосування, яка є одним із документів, необхідних для отримання Дозволу на придбання зброї.',
      ],
    },
    {
      title: 'Друге заняття: ПІСТОЛЕТ. ІНТЕНСИВ.',
      program: [
        'Заходи безпеки.',
        'Види проблем при стрільбі та їх усунення.',
        'Стрільба зі зміною рук.',
        'Стрільба з різних положень.',
        'Стрільба з укриття.',
        'Прицільна стрільба. Дистанція. Перенос пострілу.',
        'Носіння зброї. Види кобур.',
      ],
      costList: [
        'Тривалість: 2 години',
        'Вартість: 5400 грн. (група до 2х осіб)',
        '100 пострілів',
      ],
    },
    {
      title: 'Третє заняття: ПИСТОЛЕТ. PRO. СТРІЛЬБА У РУСІ.',
      program: [
        'Заходи безпеки.',
        'Робота з кобурою. Перший постріл.',
        'Ідентифікація цілей. Дистанція.',
        'Стрільба з переносом вогню.',
        'Стрільба в русі.',
        'Введення в Динамічну стрільбу.',
      ],
      costList: [
        'Тривалість: 2 години',
        'Вартість: 5400 грн. (група до 2х осіб)',
        '100 пострілів',
      ],
      sublist: [
        'Оренда тиру, робота інструктора, оренда зброї, набої, мішені входять до вартості Занять на Курсі.',
        'Випускники Курсу отримують право на подальше консультування з питань вибору, придбання зброї та оформлення Дозволу на зброю.',
      ],
    },
  ],
};

export const pistolCourseProgramCostData: (lang: string) => IProgramCost = (lang) => ({
  description: getTranslationByLangOrUk(lang, 'pistol_course_41'),
  headListData: [
    getTranslationByLangOrUk(lang, 'pistol_course_42'),
    getTranslationByLangOrUk(lang, 'pistol_course_43'),
  ],
  subdescription: getTranslationByLangOrUk(lang, 'pistol_course_44'),
  courseOptions: [
    {
      title: getTranslationByLangOrUk(lang, 'pistol_course_45'),
      price: getTranslationByLangOrUk(lang, 'pistol_course_46'),
      listData: [
        getTranslationByLangOrUk(lang, 'pistol_course_47'),
        getTranslationByLangOrUk(lang, 'pistol_course_48'),
        getTranslationByLangOrUk(lang, 'pistol_course_49'),
        getTranslationByLangOrUk(lang, 'pistol_course_50'),
        getTranslationByLangOrUk(lang, 'pistol_course_51'),
      ],
    },
    {
      title: getTranslationByLangOrUk(lang, 'pistol_course_52'),
      price: getTranslationByLangOrUk(lang, 'pistol_course_53'),
      listData: [
        getTranslationByLangOrUk(lang, 'pistol_course_54'),
        getTranslationByLangOrUk(lang, 'pistol_course_55'),
        getTranslationByLangOrUk(lang, 'pistol_course_56'),
        getTranslationByLangOrUk(lang, 'pistol_course_57'),
      ],
    },
    {
      title: getTranslationByLangOrUk(lang, 'pistol_course_58'),
      price: getTranslationByLangOrUk(lang, 'pistol_course_59'),
      listData: [
        getTranslationByLangOrUk(lang, 'pistol_course_60'),
        getTranslationByLangOrUk(lang, 'pistol_course_61'),
        getTranslationByLangOrUk(lang, 'pistol_course_62'),
        getTranslationByLangOrUk(lang, 'pistol_course_63'),
      ],
    },
  ],
});

interface ICertificatesData {
  title: string,
  listData: string[],
  validityPeriod: string,
  price: string,
  path: string,
  img: string,
}

export const certificatesData = (lang: string) => [
  {
    title: getTranslationByLangOrUk(lang, 'certificates_1'),
    img: certificatesDataCourse1Img,
    listData: [
      getTranslationByLangOrUk(lang, 'certificates_2'),
      getTranslationByLangOrUk(lang, 'certificates_3'),
    ],
    price: getTranslationByLangOrUk(lang, 'certificates_4'),
    validityPeriod: getTranslationByLangOrUk(lang, 'certificates_5'),
    path: '/courses/basic-course-in-handling-weapons',
  },
  {
    title: getTranslationByLangOrUk(lang, 'certificates_6'),
    img: certificatesDataCourse2Img,
    listData: [
      getTranslationByLangOrUk(lang, 'certificates_7'),
      getTranslationByLangOrUk(lang, 'certificates_8'),
    ],
    price: getTranslationByLangOrUk(lang, 'certificates_9'),
    validityPeriod: getTranslationByLangOrUk(lang, 'certificates_10'),
    path: '/courses/basic-course-in-handling-weapons',
  },
  {
    title: getTranslationByLangOrUk(lang, 'certificates_11'),
    img: certificatesDataCourse3Img,
    listData: [
      getTranslationByLangOrUk(lang, 'certificates_12'),
      getTranslationByLangOrUk(lang, 'certificates_13'),
    ],
    price: getTranslationByLangOrUk(lang, 'certificates_14'),
    validityPeriod: getTranslationByLangOrUk(lang, 'certificates_15'),
    path: '/courses/basic-fire-safety-course',
  },
  {
    title: getTranslationByLangOrUk(lang, 'certificates_16'),
    img: certificatesDataCourse4Img,
    listData: [
      getTranslationByLangOrUk(lang, 'certificates_17'),
      getTranslationByLangOrUk(lang, 'certificates_18'),
    ],
    price: getTranslationByLangOrUk(lang, 'certificates_19'),
    validityPeriod: getTranslationByLangOrUk(lang, 'certificates_20'),
    path: '/courses/basic-course-emergency-aid',
  },
];
